import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';

import { Heading, Button, Markdown, SanityImage } from '../elements';

const Section = styled.section`
  background-color: ${(props) =>
    props.background ? props.background : '#fff'};
  span {
    color: ${(props) => props.theme.mainBrandColor};
  }
`;

const ColumnWrapper = styled.div`
  flex-direction: ${(props) => (props.reverse ? '' : 'row-reverse')};
  .has-background {
    background-image: url(${(props) => props.image});
    background-position: ${(props) => props.framePosition};
    background-repeat: no-repeat;
    background-size: contain;
    padding: 20px;
  }
`;

const IndividualHeading = ({ heading, className }) => {
  return (
    <div className={`section ${className}`}>
      <div className="container">
        <Markdown className="py-4 has-text-grey-dark has-text-centered">
          {heading}
        </Markdown>
      </div>
    </div>
  );
};

const Service = ({ heading, subtitle, homeServices = [] }) => {
  return (
    <>
      {/*  special case for color */}
      <IndividualHeading heading={heading} className="pb-0" />
      {homeServices.map((item, index) => {
        return (
          <Section
            className="section"
            key={item._key}
            background={item.backgroundColor ? item.backgroundColor.hex : 'fff'}
          >
            <div className="container">
              <ColumnWrapper
                className="columns is-variable is-8 is-vcentered"
                reverse={index % 2 === 0}
                image={
                  index % 2 === 0
                    ? '/images/frame-left.png'
                    : '/images/frame-right.png'
                }
                framePosition={index % 2 === 0 ? 'left' : 'right'}
              >
                <div className="column is-6">
                  {item.image && item.image.asset && (
                    <div className="has-background">
                      <SanityImage
                        className="has-background"
                        alt={item.image.alt || 'Capextax'}
                        fluid={item.image.asset.id}
                      />
                    </div>
                  )}
                </div>
                <div className="column is-6">
                  <h1 className="title is-6 has-text-weight-bold has-text-orange">
                    {item.title}
                  </h1>
                  <Heading dark size="is-2">
                    {item.subtitle}
                  </Heading>
                  <Markdown className="is-6 pt-4">{item.description}</Markdown>
                  <Link to={`${item.linkTo ? item.linkTo.current : '#'}`}>
                    <Button fullWidth>Learn More</Button>
                  </Link>
                </div>
              </ColumnWrapper>
            </div>
          </Section>
        );
      })}
      <div className="">
        <IndividualHeading
          heading={subtitle}
          className="pt-0 has-background-light-tan"
        />
      </div>
    </>
  );
};

export default Service;
